import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { urlService } from '../../routing/urlsService';
import ReportPage from './ReportPage';

const ReportsModule: React.FC = () => {
  return (
    <Switch>
      <Route exact path={urlService.reports()} component={ReportPage} />
    </Switch>
  );
};

export default ReportsModule;
